module.exports = __webpack_public_path__ + "img/logo-large.5ad224ef.png";